export interface PersonalSecurityEventResult {
  readonly eventType: string;
  readonly occurredAt: string;
}

export async function listPersonalSecurityEvents(): Promise<
  readonly PersonalSecurityEventResult[]
> {
  const response = await fetch('/api/auth/security-events', {
    method: 'GET',
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error('Personal security journal unavailable.');
  return (await response.json()) as readonly PersonalSecurityEventResult[];
}
